import { useMutation } from "react-query";
import api from "../../client";
import { PlacementEnvironmentTemplateListItem } from "../../types/placement-environment-template";

const deleteData = async (
  id: string | undefined,
): Promise<PlacementEnvironmentTemplateListItem> => {
  const { data } = await api.delete(`/placement-environment-templates/${id}`);

  return data;
};

export const useDeletePlacementEnvironmentTemplate = (
  id: string | undefined,
) => {
  return useMutation(() => {
    return deleteData(id);
  });
};
